import { render, staticRenderFns } from "./WifiCard.vue?vue&type=template&id=366f838e"
import script from "./WifiCard.vue?vue&type=script&lang=js"
export * from "./WifiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports